export default {
  "fr": {
    "company_startup_tech_id_list_198": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FinTech"])},
    "company_startup_tech_id_list_375": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GreenTech"])},
    "company_startup_tech_id_list_376": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["HealthTech"])},
    "company_startup_tech_id_list_378": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DeepTech"])},
    "company_startup_tech_id_list_379": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EdTech"])},
    "company_startup_tech_id_list_381": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FoodAgritech"])}
  },
  "en": {
    
  }
}